if (!customElements.get('collection-with-filters')) {
  class CollectionWithFilters extends HTMLElement {
    form;

    constructor() {
      super();
    }

    connectedCallback() {
      if (
        window.location.search.includes('sort_by') ||
        window.location.search.includes('filter.')
      ) {
        window.scrollTo({
          top:
            this.closest('.shopify-section').offsetTop -
            document.querySelector('.shopify-section-group-header-group').scrollHeight,
        });
      }

      this.form = document.querySelector('.collection__filters-bar form');
      this.form.addEventListener('change', this.onChange.bind(this));
      this.querySelectorAll('[data-remove-url]').forEach((button) => {
        button.addEventListener('click', () => {
          window.location.href = button.dataset.removeUrl;
        });
      });

      document.querySelectorAll('.collection__filters-items details').forEach((detail) => {
        detail.addEventListener('toggle', () => {
          if (detail.open) {
            document
              .querySelectorAll('.collection__filters-items details')
              .forEach((otherDetail) => {
                if (otherDetail !== detail && otherDetail.open) {
                  otherDetail.removeAttribute('open');
                }
              });
          }
        });
      });
    }

    onChange(event) {
      this.form.submit();
    }
  }
  customElements.define('collection-with-filters', CollectionWithFilters);
}
